var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderDetailArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45175 4.3217L7.31175 2.1817L6.00509 0.86837C5.45175 0.315037 4.55175 0.315037 3.99842 0.86837L0.545086 4.3217C0.0917526 4.77504 0.418419 5.54837 1.05175 5.54837L4.79175 5.54837L8.94509 5.54837C9.58509 5.54837 9.90509 4.77504 9.45175 4.3217Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDetailArrowUp);
export default __webpack_public_path__ + "static/media/order-detail-arrow-up.453769b4c82f36eca68f5ee4579115e8.svg";
export { ForwardRef as ReactComponent };